export enum SignInProvider {
  APPLE,
  GOOGLE,
  MICROSOFT,
}
